<template>
<div class="modal" v-if="loading">
  <div class="spinner">
    <half-circle-spinner :animation-duration="1000" :size="size" :color="color" />
  </div>
</div>
</template>

<script>
import {
  HalfCircleSpinner
} from 'epic-spinners'

export default {
  components: {
    HalfCircleSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: "#2DADFC",
    }
  },
  data() {
    return {}
  }
}
</script>

<style>
.modal {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
  opacity: 1;
}

.spinner {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
